module.exports = __webpack_public_path__ + "img/cbr-quest-test.a5a129b4.svg";